
export type LanguageJson = { name: string; code: string };
export type CountryJson = { name: string; alpha2Code: string };

export function buildLanguageMap(languages: LanguageJson[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const l of languages) if (l?.name && l?.code) map[l.name] = l.code;
  return map;
}

export function buildCountryMap(countries: CountryJson[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const c of countries) if (c?.name && c?.alpha2Code) map[c.name.toLowerCase()] = c.alpha2Code.toLowerCase();
  return map;
}

export function getFlagSrc(languageName: string, languageMap: Record<string, string>): string {
  const code = languageMap[languageName];
  return code ? `assets/icons/flags/square/${code}.svg` : 'assets/icons/flags/square/default.svg';
}

export function getFlagEmoji(location: string | null | undefined, countryMap: Record<string, string>): string {
  if (!location) return '🏳️';
  const country = location.split(',').pop()?.trim().toLowerCase() || '';
  const code = countryMap[country];
  return code ? code.toUpperCase().replace(/./g, ch => String.fromCodePoint(127397 + ch.charCodeAt(0))) : '🏳️';
}
